import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jira-black",
  "use": "icon-jira-black-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-jira-black\"><path d=\"M.775 12.675C6.934 18.877 3.641 15.558 12.021 24c17.596-17.719.728-.783 11.2-11.33a.947.947 0 0 0 0-1.341v.001c-3.38-3.408-7.856-7.964-11.2-11.33C4.345 7.73.775 11.33.775 11.33a.96.96 0 0 0 0 1.345zM12.02 8.452 15.546 12l-3.525 3.548L8.495 12l3.525-3.548z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol